import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FileService } from 'src/app/services/file/file.service';

@Component({
  selector: 'app-card-user',
  templateUrl: './card-user.component.html',
  styleUrls: ['./card-user.component.sass']
})
export class CardUserComponent implements OnInit, OnDestroy {
  @Input() redirectUrl: string
  @Input() data
  background_image: any;
  fileServiceSub: Subscription;
  lastSeen: Date;

  constructor(private fileService: FileService) { }

  ngOnInit(): void {
    this.background_image = `url("${this.data.avatar?.url_small
      || this.data.avatar?.url
      || '/assets/images/avatar.svg'}")`
    this.lastSeen = this.data.last_seen || this.data.created_at
  }

  ngOnDestroy() {
    if (this.fileServiceSub) this.fileServiceSub.unsubscribe()
  }

}
